import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    mapkitToken: String,
    stations: Array,
    logoImageUrl: String,
    selectedStationId: Number,
  }

  // Ths mapkit-js map will be bound to a specific DOM element #map. turbo will remove the element
  // and later, when coming back to the map, reintroduce it, which breaks the binding, which
  // in particular breaks the android app.
  //
  // https://github.com/cleancar/cleancar-web/issues/375
  //
  // To circumvent this issue, we move the map into a turbo-permanent element, which won't be
  // affected by turbo. This means, however:
  //
  // - We need to make sure that the map is not added a second time by a turbo visit
  // - We need to manually hide and show the permament map
  //
  initialize() {
    // Move the #stations-map element into #permanent-content
    //
    const stationsMapElement = document.getElementById("stations-map")
    this.move_map_element_to_permanent_content(stationsMapElement)
  }

  move_map_element_to_permanent_content(map_element) {
    const permanentContentElement = document.getElementById("permanent-content")
    if (map_element && permanentContentElement && map_element.parentElement !== permanentContentElement) {
      permanentContentElement.appendChild(map_element)
    }
  }

  connect() {

    let token = this.mapkitTokenValue
    let stations = this.stationsValue
    let logo_image_url = this.logoImageUrlValue
    let selected_station_id = this.selectedStationId

    // Hide and show the permanent map manually
    //
    if (window.location.pathname.includes("/stations") && !window.location.pathname.includes("/stations/")) {
      document.getElementById("stations-map").style.display = "block"
    } else {
      document.getElementById("stations-map").style.display = "none"
    }

    // Init the mapkit-js map only once
    //
    if (! this.map_init_done) {
      this.map_init_done = true

      mapkit.init({
        authorizationCallback: function(done) {
          done(token)
        }
      });

      var map = new mapkit.Map("map");

      // When showing the translucent side panel, shift the map a little to the right.
      if (window.innerWidth >= 768) {
        map.padding = new mapkit.Padding({top: 0, left: 600, bottom: 0, right: 0})
      }
      // cameraBoundary: mapkit.MapRect(x, y, width, height)

      // When on mobile, shift the map a little up to make room for the tab bar.
      if (navigator.userAgent.includes("Jumpstart") && window.innerWidth < 768) {
        map.padding = new mapkit.Padding({top: 0, left: 0, bottom: 50, right: 0})
      }

      var marker_annotations = []
      stations.forEach((station) => {
        if (station.longitude && station.latitude) {
          var coordinate = new mapkit.Coordinate(station.latitude, station.longitude)
            var marker_annotation;
            if (document.body.classList.contains("demo_mode")) {
              marker_annotation = new mapkit.MarkerAnnotation(coordinate)
            } else {
              marker_annotation = new mapkit.ImageAnnotation(coordinate, {
                title: station.name,
                url: {
                  2: logo_image_url
                }
              })
            }

            marker_annotation.addEventListener("select", event => {
              let target_path = this.target_path_for_station(station)

              if (navigator.userAgent.includes("Jumpstart") || navigator.userAgent.includes("Turbo Native")) {
                Turbo.visit(target_path)
              } else {
                document.getElementById("bottom-sheet").classList.add("active")
                document.getElementById("station-body").setAttribute("src", target_path)
              }
            })

          if (station.id == selected_station_id) {
            marker_annotation.trigger("select")
          }

          marker_annotations.push(marker_annotation)
        }
      })

      map.showsUserLocationControl = true
      map.tintColor = '#2D74AB'
      map.showItems(marker_annotations)

    }
  }

  maximize_bottom_sheet() {
    document.getElementById("bottom-sheet").classList.add("full")
  }

  close_bottom_sheet() {
    document.getElementById("bottom-sheet").classList.remove("full", "active")
  }

  reduce_bottom_sheet() {
    document.getElementById("bottom-sheet").classList.remove("full")
  }

  bottom_sheet_scrolled(event) {
    if (document.getElementsByClassName("bottom-sheet-body")[0].scrollTop <= 0) {
      this.reduce_bottom_sheet()
    }
    if (document.getElementsByClassName("bottom-sheet-body")[0].scrollTop > 0) {
      this.maximize_bottom_sheet()
    }
  }

  target_path_for_station(station) {
    const params = new URLSearchParams({
      select_current_station: this.is_selecting_current_station(),
      wizard: this.is_wizard(),
      modal: this.is_modal(),
      current_station_return_path: this.get_current_station_return_path(),
    });

    return `/stations/${station.id}?${params.toString()}`;
  }

  is_selecting_current_station() {
    const queryParams = new URLSearchParams(window.location.search)
    return queryParams.get('select_current_station') === "true";
  }

  is_wizard() {
    const queryParams = new URLSearchParams(window.location.search)
    return queryParams.get('wizard') === "true"
  }

  is_modal() {
    const queryParams = new URLSearchParams(window.location.search)
    return queryParams.get('modal') === "true"
  }

  get_current_station_return_path() {
    const queryParams = new URLSearchParams(window.location.search)
    return queryParams.get('current_station_return_path') || window.location.pathname
  }
}